---
id: go-shared-apiserver
title: Shared API server
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - apiserver
  - gin
  - shared
---

## Product Overview

### Who it serves

This shared package provides a standard HTTP server wrapper for Go microservices so services can start consistently with common middleware and shutdown behavior.

### Primary workflow

Service mains create a new app instance, attach routes and middleware, then run the server with a consistent startup and graceful shutdown lifecycle.

### Business rules

Services can opt into shared error handling, CORS, and recovery middleware, while leaving route definitions owned by the calling service.

### Outcomes

Microservices boot with uniform configuration patterns, predictable middleware ordering, and safe shutdown handling.

### Out of scope

Request-level business logic, authentication policies, and domain-specific routing remain within each service.

## Technical Overview

### Architecture flow

`app` stores route definitions and middleware, applies them to a Gin engine, and runs an HTTP server with compression and graceful shutdown.

### Entry points

`NewApp` in `apps/micro-services/go-shared/apiserver/app.go` constructs the server, while chainable setters such as `SetPort`, `SetCORS`, `SetErrorHandler`, and `SetRecovery` configure behavior before `Run` starts the server.

### Key modules

Route binding is implemented by `setRoutes` in `app.go`, which walks `documentbuilder.Routes` trees and registers handlers with Gin.

### Data sources and sinks

The server listens on the configured port and routes HTTP requests into Gin handlers supplied by services.

### Integrations and side effects

The server integrates with shared middleware (`middleware.CORS`, `middleware.ErrorHanlder`), applies gzip compression via `gorilla/handlers`, and logs lifecycle events.

### Constraints and risks

If services omit a port or shutdown duration, defaults are used, and misconfigured route trees can terminate the process via fatal logging.

## Changelog

- 2026-01-30: Initial documentation.
